module.exports = "/images/card-image-6.jpg?b26faf1e51482f6816e4d1a528fc5818";